import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import { BootstrapVue, BootstrapVueIcons  } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTwitter, faInstagram, faLinkedinIn, faMediumM} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vueHeadful from 'vue-headful'
import VueGtag from 'vue-gtag'
import VueMeta from 'vue-meta'
import VueMouseflow from 'vue-mouseflow'


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

library.add(faTwitter);
library.add(faInstagram);
library.add(faLinkedinIn);
library.add(faMediumM);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('vue-headful', vueHeadful);

Vue.config.productionTip = false;

Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueMeta)
Vue.use(VueMouseflow, { tracking_key: '72078139-a9d0-4b3e-90da-3f12f7bd5831' });
Vue.use(VueGtag, {
  config: { 
    id: "UA-129590213-1",
    params: {}
  }
}, router);

export const eventBus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
